import { commonActions } from 'common/context/CommonSlice';
import { useAppDispatch } from 'common/context/hooks';
import { useFetch } from 'common/hooks/useFetchSwr';
import { AdminTablePaths } from 'common/model/AdminTablePaths';
import { useEffect } from 'react';

export const BrandSettingsManager = () => {
  const dispatch = useAppDispatch();

  const { data: brandSettings } = useFetch<Setting>(AdminTablePaths.SETTING);

  useEffect(() => {
    if (brandSettings) dispatch(commonActions.setSettings(brandSettings));
  }, [brandSettings, dispatch]);

  return null;
};
